var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "base-card",
        [
          _c("v-card-title", [_vm._v(" Control de Folios ")]),
          _c(
            "v-card-text",
            [
              _vm.isAdmin
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-select", {
                            ref: "cliente",
                            attrs: {
                              items: _vm.detailClients,
                              "item-text": "text",
                              "item-value": "IdCompania",
                              label: "Compañia",
                              "prepend-inner-icon": "mdi-sitemap",
                              error: _vm.companySelectorError,
                              rules: [_vm.validateCompanyField],
                              "error-messages": _vm.helperSelectorText,
                              filter: "",
                              "search-input": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend-item",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "search-field",
                                                    attrs: {
                                                      placeholder: "Buscar",
                                                      "prepend-inner-icon":
                                                        "mdi-magnify",
                                                      "hide-details": "",
                                                    },
                                                    model: {
                                                      value: _vm.search,
                                                      callback: function ($$v) {
                                                        _vm.search = $$v
                                                      },
                                                      expression: "search",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              766180807
                            ),
                            model: {
                              value: _vm.idCompania,
                              callback: function ($$v) {
                                _vm.idCompania = $$v
                              },
                              expression: "idCompania",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "2" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              staticStyle: {
                                "background-color": "rgb(204 33 40)",
                                color: "white !important",
                              },
                              on: { click: _vm.searchCompany },
                            },
                            [_vm._v(" Buscar ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isHKA && _vm.idCompania > 0 && _vm.isSearchCompany
                ? _c(
                    "v-form",
                    { ref: "foliosForm" },
                    [
                      _vm.isAdmin
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "4" } },
                                [
                                  _c("v-switch", {
                                    staticClass: "mb-6",
                                    attrs: {
                                      label: `${
                                        _vm.paramControlFolios
                                          ? "(Activo)"
                                          : "(Inactivo)"
                                      } Control de folios`,
                                      "hide-details": "",
                                      inset: "",
                                    },
                                    model: {
                                      value: _vm.paramControlFolios,
                                      callback: function ($$v) {
                                        _vm.paramControlFolios = $$v
                                      },
                                      expression: "paramControlFolios",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex align-center",
                                  attrs: { cols: "12", sm: "4" },
                                },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.loadingFoliosHKA,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.actualizarFoliosDesdeHKA,
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("mdi-refresh"),
                                                    ]),
                                                    _vm._v(
                                                      " Actualizar folios "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        4015770353
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Actualizar folios desde Proveedor Tecnológico (PT)"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "FoliosComprados",
                                attrs: {
                                  label: "Cantidad de folios comprados",
                                  "prepend-inner-icon": "mdi-note-multiple",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.dataFolios.FoliosComprados,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataFolios,
                                      "FoliosComprados",
                                      $$v
                                    )
                                  },
                                  expression: "dataFolios.FoliosComprados",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "FoliosDisponibles",
                                attrs: {
                                  label: "Cantidad de folios disponibles",
                                  "prepend-inner-icon": "mdi-note-multiple",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.dataFolios.FoliosDisponibles,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataFolios,
                                      "FoliosDisponibles",
                                      $$v
                                    )
                                  },
                                  expression: "dataFolios.FoliosDisponibles",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "FoliosAlertar",
                                attrs: {
                                  label: "Alertar cuando falten Folios (%)",
                                  "prepend-inner-icon": "mdi-note-multiple",
                                  type: "number",
                                  clearable: "",
                                  rules: _vm.formRulesFoliosAlertar,
                                  "error-messages": _vm.errorMessages,
                                },
                                model: {
                                  value: _vm.dataFolios.FoliosAlertar,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataFolios,
                                      "FoliosAlertar",
                                      $$v
                                    )
                                  },
                                  expression: "dataFolios.FoliosAlertar",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "FoliosRepetirAlerta",
                                attrs: {
                                  label: "Repetir alerta cada (Folios)",
                                  "prepend-inner-icon": "mdi-reload",
                                  type: "number",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                },
                                model: {
                                  value: _vm.dataFolios.FoliosRepetirAlerta,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataFolios,
                                      "FoliosRepetirAlerta",
                                      $$v
                                    )
                                  },
                                  expression: "dataFolios.FoliosRepetirAlerta",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12", sm: "10" } }),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "2" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  on: { click: _vm.validateFoliosData },
                                },
                                [_vm._v(" Guardar ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-alert",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.successAlert,
                                  expression: "successAlert",
                                },
                              ],
                              attrs: { type: "success", text: "" },
                            },
                            [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider"),
              _vm.isHKA &&
              _vm.isAdmin &&
              _vm.idCompania > 0 &&
              _vm.isSearchCompany
                ? _c(
                    "v-form",
                    { ref: "foliosFormToken" },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-card-title", [
                            _vm._v(" Token temporal para folios "),
                          ]),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _vm._v(
                              " Genera un token para habilitar temporalmente la facturación de contingencia mientras el cliente adquiere nuevos folios. "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "casoSalesforce",
                                attrs: {
                                  label: "Nro Caso Salesforce",
                                  rules: _vm.formCasoSalesforceRules,
                                  "prepend-inner-icon": "mdi-note-multiple",
                                  type: "number",
                                },
                                model: {
                                  value: _vm.dataTokenFolios.casoSalesforce,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataTokenFolios,
                                      "casoSalesforce",
                                      $$v
                                    )
                                  },
                                  expression: "dataTokenFolios.casoSalesforce",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "2" } },
                            [
                              _c("v-text-field", {
                                ref: "horasGracia",
                                attrs: {
                                  label: "Horas de Gracia Folios",
                                  rules: _vm.formRulesHorasGraciaFolios,
                                  counter: "2",
                                  "prepend-inner-icon": "mdi-note-multiple",
                                  type: "number",
                                },
                                model: {
                                  value: _vm.dataTokenFolios.horasGracia,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataTokenFolios,
                                      "horasGracia",
                                      $$v
                                    )
                                  },
                                  expression: "dataTokenFolios.horasGracia",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "2" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-3",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  attrs: { block: "" },
                                  on: { click: _vm.generateTokenFolios },
                                },
                                [_vm._v(" Generar Token ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isHKA === false
                ? _c("v-row", [
                    _c("div", { staticClass: "text-center ml-10 mt-5" }, [
                      _c("span", { staticClass: "text-subtitle-1" }, [
                        _vm._v(
                          " Opción no disponible para el Proveedor Tecnológico EDN "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "v-row",
                [
                  _c(
                    "v-alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errorAlert,
                          expression: "errorAlert",
                        },
                      ],
                      attrs: { type: "warning", text: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.msgErrorAlert) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        "max-width": "500",
                        transition: "dialog-bottom-transition",
                      },
                      model: {
                        value: _vm.dialogShowTokenFolios,
                        callback: function ($$v) {
                          _vm.dialogShowTokenFolios = $$v
                        },
                        expression: "dialogShowTokenFolios",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-toolbar",
                            {
                              staticStyle: {
                                "background-color": "rgb(204 33 40)",
                                color: "white !important",
                              },
                              attrs: { dark: "" },
                            },
                            [
                              _c("v-toolbar-title", [_vm._v("Token Generado")]),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-auto",
                                  attrs: { icon: "" },
                                  on: { click: _vm.closeDialogShowTokenFolios },
                                },
                                [_c("v-icon", [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card-text",
                            { staticClass: "text-h3 text-center mt-4" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.dataTokenFolios.tokenGenerado) +
                                  " "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "text-center mt-2" }, [
                            _c("span", { staticClass: "text-subtitle-1" }, [
                              _vm._v(" Válido por 5 minutos "),
                            ]),
                          ]),
                          _c(
                            "v-card-actions",
                            { staticClass: "justify-end" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "" },
                                  on: { click: _vm.closeDialogShowTokenFolios },
                                },
                                [_vm._v(" Cerrar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }